import React from "react";
import { useBnbSelector } from "../../../../redux/store";
import * as Flex from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import Container from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Container";
import * as Form from "../../../../../../../common-deprecated/styles/v2/toyota/components/Form";
import * as ModelStyles from "../styles/Model";
import ModelFilterSlider from "./ModelFilterSlider";
import { BnbLabel } from "../../../../utils/labels";
import type { ModelGradeType } from "../../../../../../../common-deprecated/types/CommonTypes";

type EquipmentModelStepFilterType = {
    selectFilterItem: (id: string) => void;
    deselectFilterItem: (id: string) => void;
    itemIsSelected: boolean;
    grade: ModelGradeType;
};

const EquipmentModelStepFilter = (props: EquipmentModelStepFilterType): JSX.Element => {
    const { selectFilterItem, deselectFilterItem, itemIsSelected, grade } = props;
    const model = useBnbSelector((state) => state.model);
    const filterItems = useBnbSelector((state) => state.model.filterItems);

    return (
        <Container my={4}>
            <Flex.Row justifyContent="space-between">
                <Flex.Col width={{ _: 1, md: 2 / 6, lg: 1 / 2 }} display="flex" flexDirection="column">
                    <ModelStyles.Title>{model.name}</ModelStyles.Title>
                    <div>
                        {filterItems.map((equipmentItem) => (
                            <>
                                <Form.Check>
                                    <input
                                        type="radio"
                                        name="roof"
                                        id={`${equipmentItem.id}-${itemIsSelected.toString()}`}
                                        checked={itemIsSelected}
                                        onClick={() => selectFilterItem(equipmentItem.id)}
                                    />
                                    <label htmlFor={`${equipmentItem.id}-${itemIsSelected.toString()}`}>
                                        <BnbLabel
                                            label="selectEquipmentItem"
                                            params={{ equipment: equipmentItem.name }}
                                        />
                                    </label>
                                </Form.Check>
                                <Form.Check>
                                    <input
                                        type="radio"
                                        name="roof"
                                        id={`${equipmentItem.id}-${(!itemIsSelected).toString()}`}
                                        checked={!itemIsSelected}
                                        onClick={() => deselectFilterItem(equipmentItem.id)}
                                    />
                                    <label htmlFor={`${equipmentItem.id}-${(!itemIsSelected).toString()}`}>
                                        <BnbLabel
                                            label="deselectEquipmentItem"
                                            params={{ equipment: equipmentItem.name }}
                                        />
                                    </label>
                                </Form.Check>
                            </>
                        ))}
                    </div>
                </Flex.Col>
                <Flex.Col width={{ _: 1, md: 4 / 6, lg: 1 / 2 }}>
                    <ModelFilterSlider grade={grade} />
                </Flex.Col>
            </Flex.Row>
        </Container>
    );
};

export default EquipmentModelStepFilter;
